import React, { useEffect, useRef } from 'react';
import { stripOutsideRC } from '../../../cms/layout/util';
import { GoldSilverLayout } from './styles';

interface GoldSilverContentProps {
  cmsContent?: string;
}

export const GoldSilverContent = ({
  cmsContent,
}: GoldSilverContentProps): JSX.Element => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    stripOutsideRC(contentRef.current);
  }, [cmsContent]);

  return (
    <GoldSilverLayout>
      <div
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: cmsContent ?? '' }}
      />
    </GoldSilverLayout>
  );
};
